import { EditOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Collapse, Input, Modal, Space } from "antd";
import { Shield } from "lucide-react";
import React, { useEffect, useState } from "react";
import PermissionMatrix from "./PermissionMatrix";
import PermissionManager from "../../managers/PermissionManager";
import { ALL_PERMISSION_PAGES } from "../../Config";
import DataHelper from "../../helpers/DataHelper";

const { Panel } = Collapse;

const RolesPermissions = ({ allowEdit = true, data = [], parentProps = {}, reloadUserRoles = () => { }, planData = null }) => {
  const normalizeRoles = (roles) =>
    roles.map((role) => ({
      id: role.userroleid,
      name: role.userrolename,
      description: role.userroledescription,
      permissions: Object.keys(role.userrolepermissions).map((key) => ({
        ...JSON.parse(JSON.stringify(role.userrolepermissions[key])), // deep clone
        id: key,
        name: key,
      })),
    }));

  const [roles, setRoles] = useState([]);
  const [originalRoles, setOriginalRoles] = useState([]);
  const [activeKeys, setActiveKeys] = useState([]);
  const [editMode, setEditMode] = useState({});

  useEffect(() => {

    console.log("use effect " + JSON.stringify(editMode))
  }, [editMode])
  // 🟢 Rehydrate roles when data changes
  useEffect(() => {
    if (data && data.length > 0) {
      const normalized = normalizeRoles(data);
      setRoles(normalized);
      setOriginalRoles(normalized);
    }
  }, [data]);

  const togglePermission = (roleId, recordId, action) => {
    console.log("togglePermission " + roleId + " " + recordId + " " + action)
    setRoles((prevRoles) =>
      prevRoles.map((role) => {
        console.log("role.id " + role.id + " vs " + roleId)


        const currentFullPermissions = PermissionManager.getAllPermiossionsInactive().map(baseItem => {
          const current = role.permissions.find(o => o.id === baseItem.id);
          return current ? { ...baseItem, ...current } : baseItem;
        });
        const dataSource = role.id !== roleId
          ? role
          : {
            ...role,
            permissions: currentFullPermissions.map((p) => {
              return p.id === recordId ? { ...p, [action]: (!p[action]) ? 1 : 0 } : p
            }
            ),
          }

        console.log("dataSource " + JSON.stringify(dataSource))

        const filteredPermissions = dataSource.permissions.filter((page) => {
          // Keep only pages with at least one permission set to true, ignore name and id
          return PermissionManager.actionKeys.some((action) => {
            return page[action] == 1;
          });
        });


        dataSource.permissions = filteredPermissions;
        return dataSource;
      }
      )
    );
  };

  const getNormalizedPermissions = (role, isEditMode = false) => {
    const existing = role.permissions || {};
    console.log("!!!!!! role " + JSON.stringify(role))

    const pages = isEditMode
      ? ALL_PERMISSION_PAGES
      : existing.filter((page) => {
        return Object.values(page).some((val) => !!val);
      });

    return pages.map((page) => {
      const perm = existing[page] || {};
      return {
        id: page,
        name: page,
        canRead: !!perm.canRead,
        canCreate: !!perm.canCreate,
        canUpdate: !!perm.canUpdate,
        canDelete: !!perm.canDelete,
        canPublish: !!perm.canPublish,
        canUpload: !!perm.canUpload,
      };
    });
  };

  const handleCancel = (roleId) => {
    const original = originalRoles.find((r) => r.id === roleId);
    if (!original) return;

    // 🟢 Restore the full original role, including name and permissions
    setRoles((prev) =>
      prev.map((r) => (r.id === roleId ? { ...original } : r))
    );

    console.log("cancel role id " + roleId);

    setEditMode((prev) => ({ ...prev, [roleId]: false }));
  };


  const handleSave = (roleId) => {
    if (!parentProps)
      return;

    console.log("handleSave role id " + roleId)

    // setEditMode((prev) => ({ ...prev, [roleId]: false }));
    const updatedRole = roles.find((r) => r.id === roleId);
    if (!updatedRole) return;
    console.log("✅ Updated role:", updatedRole);
    setOriginalRoles((prev) =>
      prev.map((r) => (r.id === roleId ? { ...updatedRole } : r))
    );
    console.log("b4 editmode " + JSON.stringify(editMode))

    const newEditMode = { ...editMode, [roleId]: false }

    console.log("roleId " + JSON.stringify(newEditMode))

    const { requestServerPost, usermaintoken } = parentProps;


    // console.log("convertedRole " + JSON.stringify(updatedRole))
    // return;
    const convertedRole = PermissionManager.convertRoleToSubmittable(updatedRole);

    const params = {
      roleid: convertedRole.userroleid,
      rolename: convertedRole.userrolename,
      rolepermission: convertedRole.userrolepermission
    };

    requestServerPost("update_role", params, { 'Content-Type': "application/json" }, (response) => {
      Modal.success({ content: `Successfully updated the user role ${convertedRole.userrolename}`, onOk: () => { console.log("modal closed"); } })
      reloadUserRoles();
    }, usermaintoken);
  };

  const getActionLabel = (action) =>
  ({
    canRead: "View",
    canCreate: "Create",
    canUpdate: "Edit",
    canDelete: "Delete",
    canPublish: "Publish",
    canUpload: "Upload",
  }[action] || action);

  const isPermissionLocked = ((menuName, action) => {
    console.log("isPermissionLocked " + menuName + " " + action)
    console.log("planData " + JSON.stringify(planData))
    if (planData && "permissions" in planData) {
      const planPermissions = planData.permissions;

      if (menuName in planPermissions) {
        const perm = planPermissions[menuName];

        const result = DataHelper.getCaseInsensitiveFromObject(perm, action);

        //disable both -1 and 0 for now
        if (result !== undefined) {
          return result <= 0;
        }
        return false
      }
      return false
    }
    return false;
  });

  const hasOverride = () => false;
  const toggleBrandOverride = () => { };
  const getEffectivePermission = (roleID, recordID, action) => {
    const role = roles.find((r) => r.id === roleID);
    if (!role) return false;
    const permission = role.permissions.find((p) => p.id === recordID);
    if (!permission) return false;
    return !!permission[action];
  };

  const handleRoleNameChange = (roleId, newName) => {
    setRoles((prevRoles) =>
      prevRoles.map((role) =>
        role.id === roleId ? { ...role, name: newName } : role
      )
    );
  };
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      {roles.map((role) => (
        <Collapse
          key={role.id}
          bordered={false}
          accordion
          className="custom-collapse"
          activeKey={activeKeys}
          onChange={(keys) => setActiveKeys(keys)}
          style={{ borderRadius: 12, border: '1px solid #f1f5f9', boxShadow: '0 1px 3px rgba(0,0,0,0.04)', overflow: 'hidden', marginBottom: 4 }}
        >
          <Panel
            style={{ background: '#fff' }}
            header={
              editMode[role.id] ? (
                <Input
                  value={role.name}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => handleRoleNameChange(role.id, e.target.value)}
                  style={{ width: 220, fontWeight: "500", borderRadius: 6 }}
                  placeholder="Enter role name"
                />
              ) : (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <Shield size={14} color="#6366f1" />
                  <span style={{ fontWeight: 600, fontSize: 14, color: '#0f172a' }}>{role.name}</span>
                </span>
              )
            }
            key={role.id}
            extra={
              <Space size={6}>
                {editMode[role.id] && (
                  <button
                    onClick={(event) => { event.stopPropagation(); handleCancel(role.id); }}
                    style={{ height: 30, padding: '0 12px', borderRadius: 8, background: '#fef2f2', border: '1px solid #fecaca', color: '#ef4444', fontSize: 12, fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 4 }}
                  >
                    <CloseOutlined style={{ fontSize: 11 }} /> Cancel
                  </button>
                )}
                {allowEdit && (
                  <button
                    onClick={(event) => {
                      event.stopPropagation();
                      if (editMode[role.id]) handleSave(role.id);
                      setEditMode((prev) => ({ ...prev, [role.id]: !prev[role.id] }));
                      setActiveKeys((prev) =>
                        prev ? (prev.includes(role.id) ? prev : [...prev, role.id]) : [role.id]
                      );
                    }}
                    style={{
                      height: 30, padding: '0 12px', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 4,
                      ...(editMode[role.id]
                        ? { background: 'linear-gradient(135deg,#6366f1,#4f46e5)', border: 'none', color: '#fff' }
                        : { background: '#f8fafc', border: '1px solid #e2e8f0', color: '#64748b' })
                    }}
                  >
                    {editMode[role.id] ? <><SaveOutlined style={{ fontSize: 11 }} /> Save</> : <><EditOutlined style={{ fontSize: 11 }} /> Edit</>}
                  </button>
                )}
              </Space>
            }
          >
            <PermissionMatrix
              role={{
                ...role,
                // permissions: getNormalizedPermissions(role, !!editMode[role.id]),
              }}
              getEffectivePermission={getEffectivePermission}
              isPermissionLocked={isPermissionLocked}
              hasOverride={hasOverride}
              toggleBrandOverride={toggleBrandOverride}
              togglePermission={togglePermission}
              getActionLabel={getActionLabel}
              isReadOnly={!editMode[role.id]}
            />
          </Panel>
        </Collapse>
      ))}
    </Space>
  );
};

export default RolesPermissions;
